<template>
  <v-container fluid tag="section" class="py-0">
    <base-material-dialog
        :title='item.data === undefined ? "政策摘要" : "政策摘要" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
      >
      <template v-slot:content>
         <v-row>
          <v-col cols="4" class="pd-c-30">
            <v-row>
              <v-col cols="12">
                <span class="size-14">政策标题：<span class="font-weight-black">{{item.data.title}}</span></span>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">政策级别：<span class="font-weight-black">{{item.data.level === 0 ? '省级' : item.data.level === 1 ? '市级' : '区县级'}}</span></span>
              </v-col>
              <v-col cols="12" md='6'>
                <span class="size-14">行政区划：<span class="font-weight-black">{{item.data.area}}</span></span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">政策来源：<span class="font-weight-black">{{item.data.typeDic.name}}</span></span>
              </v-col>
              <v-col cols="12" md='6'>
                <span class="size-14">申请周期：<span class="font-weight-black">{{item.data.startMonth}}月~{{item.data.endMonth}}月</span></span>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">知识产权：<span class="font-weight-black">{{item.data.patentNumber}}个</span></span>
              </v-col>
              <v-col cols="12" md='6'>
                <span class="size-14">固定资产：<span class="font-weight-black">{{item.data.fixedAssets}}万元</span></span>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">资产总额：<span class="font-weight-black">{{item.data.assets}}万元</span></span>
              </v-col>
              <v-col cols="12" md='6'>
                <span class="size-14">净资产额：<span class="font-weight-black">{{item.data.netAssets}}万元</span></span>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">营业收入：<span class="font-weight-black">{{item.data.income}}万元</span></span>
              </v-col>
               <v-col cols="12" md='6'>
                <span class="size-14">主营收入：<span class="font-weight-black">{{item.data.firstIncome}}万元</span></span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">利润总额：<span class="font-weight-black">{{item.data.profit}}万元</span></span>
              </v-col>
               <v-col cols="12" md='6'>
                <span class="size-14">净利润额：<span class="font-weight-black">{{item.data.netProfit}}万元</span></span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md='6'>
                <span class="size-14">研发费用：<span class="font-weight-black">{{item.data.development}}万元</span></span>
              </v-col>
              <v-col cols="12" md='6'>
                <span class="size-14">研发占比：<span class="font-weight-black">{{item.data.developmentRatio}}%</span></span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="size-14">其他资质要求：</br>
                  <v-chip v-for="(i, idx) in item.data.seniorityList" small class="mr-1 my-1" outlined :key="idx">
                    {{i}}
                  </v-chip>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="size-14" style="white-space:pre-wrap">要求描述：
                  <div>{{ item.data.abstracts }}</div>
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col class="pr-5 pt-0" cols="8">
            <div v-if="!item.data.filePath" style="text-align: center;">
              <img :src="require('@/assets/images/empty.png')" height="100%" :width="$isMobile ? '100%' : 300"/>
              <div>无附件信息...</div>
            </div>
            <iframe width="100%" height="100%" frameborder="0" @load='setSize' scrolling="no" id="bdIframe" :src="item.data.filePath"></iframe>
          </v-col>
        </v-row>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  export default {
    name: 'PolicyDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          data: null,
          show: false
        })
      }
    },
    data() {
      return {
      }
    },
    methods: {
      dialogChange (val) {
        this.item.show = val
      },
      setSize () {
        const oIframe = document.getElementById('bdIframe');
        const deviceHeight = document.documentElement.clientHeight;
        oIframe.style.height = `${Number(deviceHeight) - 10}px`; // 数字是页面布局高度差
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
